import React, { useState, useEffect } from "react";
import HouseService from "../../services/houseService";
import HouseForm from "./HouseForm";
import EditCarouselImages from "./HouseEditCarouse";

const HouseEdit = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [houses, setHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const houseService = HouseService();

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };
  const fetchHouses = async () => {
    try {
      setLoading(true);
      const response = await houseService.getHouses();

      setHouses(response); // Update state with fetched data
    } catch (error) {
      console.error("Error fetching houses:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchHouses(); // Call the function to fetch houses
  }, []);

  const filteredHouses = houses.filter((house) => {
    return house.title.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const handleDelete = async (id) => {
    const response = await houseService.deleteHouse(id);
    fetchHouses();
  };

  console.log("Filtered Houses:", filteredHouses);
  return (
    <div>
      <h1>Editar House</h1>
      <input
        id="searchBox"
        type="text"
        placeholder="Buscar Propiedad"
        name="searchBox"
        onChange={handleSearch}
      ></input>
      <button>Buscar</button>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="edit-house-cards">
          {filteredHouses.length > 0 ? (
            filteredHouses.map((house, houseIndex) => (
              <div key={house.houseId}>
                <div className="edit-house-buttons">
                  <button onClick={() => handleDelete(house.houseId)}>
                    Eliminar Propiedad
                  </button>
                </div>
                <EditCarouselImages images={house.images} />
                <HouseForm house={house} action={"edit"} />
              </div>
            ))
          ) : (
            <p>No houses match your search</p>
          )}
        </div>
      )}
    </div>
  );
};

export default HouseEdit;
